'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.subAccountListWidget = function (subscriptionModel) {
	return mmWidgets.each(this, function () {
		let subAccounts = [], authenticatedEmail;
		const widget = this,
			subaccountTemplate = widget.find('[data-mm-role~="sub-account-template"]').remove(),
			emptyListMessage = widget.find('[data-mm-role~="sub-account-list-empty"]'),
			subAccountTable = widget.find('[data-mm-role~="sub-account-table"]'),
			subAccountListFilter = widget.find('[data-mm-role~="sub-account-list-filter"]'),
			subaccountListContainer = widget.find('[data-mm-role~="sub-account-container"]'),
			showSubAccounts = () => {
				const filterVal = subAccountListFilter && subAccountListFilter.val(),
					filter = filterVal && filterVal.trim(),
					filteredSubAccounts = subAccounts.filter(subAccount => {
						if (!filter) {
							return true;
						}
						return (subAccount.email.includes(filter) || subAccount.name.includes(filter) || subAccount.role === filter);
					});
				subaccountListContainer.empty();
				if (filteredSubAccounts.length) {
					filteredSubAccounts.forEach(function (subAccount) {
						const linked = subaccountTemplate.clone(),
							removeButton = linked.find('[data-mm-role~="remove-sub-account"]'),
							toAdminButton = linked.find('[data-mm-role~="change-sub-account-admin"]'),
							toUserButton = linked.find('[data-mm-role~="change-sub-account-user"]'),
							toShow = Object.assign({}, subAccount),
							defaultsForKey = {
								role: 'linked email'
							};

						if (subAccount.role === 'admin') {
							toAdminButton.addClass('hidden');
							toUserButton.removeClass('hidden');
						} else if (subAccount.role === 'user') {
							toAdminButton.removeClass('hidden');
							toUserButton.addClass('hidden');
						} else {
							toAdminButton.addClass('hidden');
							toUserButton.addClass('hidden');
						}

						if (subAccount.email === authenticatedEmail) {
							subaccountListContainer.prepend(linked);
							removeButton.addClass('disabled');
							toAdminButton.addClass('disabled');
							toUserButton.addClass('disabled');
							toShow.email += ' (you)';
						} else {
							subaccountListContainer.append(linked);
							if (subAccount.role === 'admin') {
								toUserButton.click(function () {
									subscriptionModel.changeSubAccountRole(subAccount.email, 'user');
								});
							} else if (subAccount.role === 'user') {
								toAdminButton.click(function () {
									subscriptionModel.changeSubAccountRole(subAccount.email, 'admin');
								});
							}

							removeButton.click(function () {
								subscriptionModel.requestSubAccountRemoval(subAccount);
							}).removeClass('disabled');
						}
						Object.keys(defaultsForKey).forEach(key => {
							const selector = '[data-mm-role~="sub-account-' + key + '"]';
							linked.find(selector).text(toShow[key] || defaultsForKey[key]);
						});
						Object.keys(toShow).forEach(key => {
							const selector = '[data-mm-role~="sub-account-' + key + '"]';
							linked.find(selector).text(toShow[key] || defaultsForKey[key]);
						});
					});
					emptyListMessage.addClass('hidden');
					subAccountTable.removeClass('hidden');
				} else {
					subAccountTable.addClass('hidden');
					emptyListMessage.removeClass('hidden');
				}
			},
			applyGoldAccountInfo = function (goldAccountInfo) {
				authenticatedEmail = goldAccountInfo && goldAccountInfo.license && goldAccountInfo.license.email;
				subAccounts = (goldAccountInfo && goldAccountInfo.subscription && goldAccountInfo.subscription.subAccounts) || [];
				showSubAccounts();
			};
		subscriptionModel.addEventListener('goldAccountInfo', applyGoldAccountInfo);
		subAccountListFilter.on('keyup', showSubAccounts);
	});

};
